export default __webpack_public_path__ + "f0ff66ac3d5eff18e363ae65007905d6.svg";